export default __webpack_public_path__ + "static/gi2-ef8ada37a21a19cad401430255671df2.gif";